
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X, Award, Wallet } from "lucide-react";
import { convertScoreToWallet } from "../../../services/walletService";
import "./ScoreToWalletModal.css";

export default function ScoreToWalletModal({
  isOpen,
  onClose,
  user,
  onSuccess,
}) {
  const [points, setPoints] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const score = Number(user?.score || 0);
  const walletAmount = Number(user?.wallet_amount || 0);

  useEffect(() => {
    if (isOpen) {
      setPoints("");
      setError("");
      setLoading(false);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handlePointsChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setPoints("");
      setError("");
      return;
    }

    const number = Number(value);

    if (number < 0) {
      return;
    }

    if (number > score) {
      setPoints(score);
      setError(
        `حداکثر ${score.toLocaleString()} امتیاز قابل تبدیل است.`
      );
      return;
    }

    setPoints(number);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedPoints = Number(points);

    if (!selectedPoints || selectedPoints <= 0) {
      setError("لطفاً تعداد امتیاز را وارد کنید.");
      return;
    }

    if (selectedPoints > score) {
      setError(
        "تعداد امتیاز نمی‌تواند بیشتر از امتیاز شما باشد."
      );
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await convertScoreToWallet(
        selectedPoints
      );

      if (!response?.success) {
        setError(
          response?.message ||
            "تبدیل امتیاز با خطا مواجه شد."
        );
        return;
      }

      onSuccess({
        walletAmount: response.data.wallet_amount,
        score: response.data.score,
      });

      onClose();

    } catch (error) {
      console.error(
        "Convert score error:",
        error
      );

      setError(
        error?.response?.data?.message ||
          "خطایی در ارتباط با سرور رخ داد."
      );
    } finally {
      setLoading(false);
    }
  };

  const modal = (
    <div
      className="score-modal-overlay"
      onClick={onClose}
    >
      <div
        className="score-modal"
        onClick={(e) => e.stopPropagation()}
        dir="rtl"
      >
        <button
          type="button"
          className="score-modal-close"
          onClick={onClose}
          disabled={loading}
        >
          <X size={22} />
        </button>

        <div className="score-modal-header">

          <div className="score-modal-icon">
            <Award size={30} />
          </div>

          <h3>
            تبدیل امتیاز به کیف پول
          </h3>

          <p>
            امتیازات خود را به موجودی کیف پول
            تبدیل کنید.
          </p>

        </div>

        <div className="score-user-info">

          <div className="score-info-item">
            <span className="score-info-label">
              نام کاربر
            </span>

            <strong>
              {user?.name} {user?.lname}
            </strong>
          </div>

          <div className="score-info-item">
            <span className="score-info-label">
              امتیاز شما
            </span>

            <strong>
              {score.toLocaleString()} امتیاز
            </strong>
          </div>

          <div className="score-info-item">
            <span className="score-info-label">
              موجودی کیف پول
            </span>

            <strong className="score-wallet-value">
              {walletAmount.toLocaleString()} تومان
            </strong>
          </div>

        </div>

        <form onSubmit={handleSubmit}>

          <div className="score-input-wrapper">

            <label htmlFor="scoreToConvert">
              تعداد امتیاز برای تبدیل
            </label>

            <input
              id="scoreToConvert"
              type="number"
              min="1"
              max={score}
              value={points}
              onChange={handlePointsChange}
              placeholder={`حداکثر ${score.toLocaleString()}`}
              disabled={loading || score <= 0}
            />

            <small>
              حداکثر قابل تبدیل:{" "}
              <strong>
                {score.toLocaleString()} امتیاز
              </strong>
            </small>

          </div>

          {error && (
            <div className="score-modal-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="score-convert-button"
            disabled={
              loading ||
              score <= 0 ||
              !points ||
              Number(points) <= 0 ||
              Number(points) > score
            }
          >
            {loading ? (
              "در حال تبدیل..."
            ) : (
              <>
                <Wallet size={19} />
                تبدیل به کیف پول
              </>
            )}
          </button>

        </form>
      </div>
    </div>
  );

  return createPortal(
    modal,
    document.body
  );
}